module.exports = __webpack_public_path__ + "img/backyard-patio.ebd66801.jpg";